import styled from 'styled-components'

import { Colors } from '@fourthwall/components'

export const OptionCode = styled.div`
  font-size: 14px;
  font-weight: 500;
  display: inline-block;
  font-variant-numeric: tabular-nums;
  color: ${Colors.GS1000};
`

export const Option = styled.div`
  padding: 8px 0;
  font-size: 14px;
`

export const EmptyState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  text-align: center;
`
